import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSelect, InputNumber, Layout, InputSwitch } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './region-model';  //editable..
import RegionList from './region-list.component';

interface IProps { 
    history: History;
    root?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class RegionDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        const typeIdx = Model.optionType.findIndex((d: any) => d.key === this.state.datarow.type);
        const typeCaption = Model.optionType?.[typeIdx]?.caption|| '';
        const typeCaptionNext = Model.optionType?.[typeIdx+1]?.caption|| '';

        return (
            //editable..
            <BaseDelete history={this.props.history} caption={'Delete ' +typeCaption}
                model={Model} onLoad={this.onLoad} disableCard>              
                
                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        <InputSelect name='type' label='Type' value={this.state.datarow.type} options={Model.optionType} readOnly/>
                        {this.state.datarow.type === 'village' &&
                        <>
                        <InputNumber name='zipcode' label='Zip Code' value={this.state.datarow.zipcode} readOnly/>
                        <Input name='code' label='Region Code' value={this.state.datarow.code} readOnly/>
                        <InputNumber name='latitude' label='Latitude' value={this.state.datarow.latitude} readOnly/>
                        <InputNumber name='longitude' label='Longitude' value={this.state.datarow.longitude} readOnly/>
                        <InputNumber name='elevation' label='Elevation' value={this.state.datarow.elevation} readOnly/>
                        </>
                        }
                        {this.state.datarow.parent &&
                        <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                        }
                    </>
                    },

                    {caption: typeCaptionNext, hide: this.state.datarow.type==='village', child:
                    this.state.datarow.id > 0 &&
                        <RegionList history={this.props.history} root={this.props.root} caption={typeCaptionNext} parentId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                    },
                    ]}
                    
                    direction={this.state.datarow.type==='village'? 'column' : 'row'}
                /> 
                 
            </BaseDelete>
        );
    }
}